import {register} from 'dna-react-ioc'
import {IOnboardingLayoutStore} from '@/layouts/OnboardingLayout/IOnboardingLayoutStore'
import {OnboardingLayoutStoreSymbol} from '@/layouts'
import {MainLayoutStore} from '@/stores'
import {IApplicationProgressStore} from '@/pages/onboarding/ApplicationProgress/IApplicationProgressStore'
import {ApplicationProgressStoreSymbol} from '@/pages/onboarding/ApplicationProgress/ApplicationProgressPage'
import {ApplicationProgressStore} from '@/stores/onboarding/ApplicationProgressStore'
import {
    OnboardingStore,
    CompanyDetailsStore,
    AddOutletStore,
    ONBOARDING_STORE_SYMBOLS,
    OnboardingAddPersonStore,
    IOnboardingStore
} from '@/stores/onboarding'
import {OnboardingBankAccountStore} from '@/stores/onboarding/OnboardingBankAccountStore'
import {ApplicationStepsStore} from '@/stores/onboarding/ApplicationStepsStore'

export const onboardingInitState = () => {
    register<IOnboardingLayoutStore>(OnboardingLayoutStoreSymbol)
        .to(MainLayoutStore)
        .inSingletonScope()

    register<IApplicationProgressStore>(ApplicationProgressStoreSymbol)
        .to(ApplicationProgressStore)
        .inSingletonScope()

    register<IOnboardingStore>(ONBOARDING_STORE_SYMBOLS.OnboardingStore)
        .to(OnboardingStore)
        .inSingletonScope()

    register<CompanyDetailsStore>(ONBOARDING_STORE_SYMBOLS.CompanyDetailsStore)
        .to(CompanyDetailsStore)
        .inSingletonScope()

    register<AddOutletStore>(ONBOARDING_STORE_SYMBOLS.AddOutletStore)
        .to(AddOutletStore)
        .inSingletonScope()

    register<OnboardingBankAccountStore>(ONBOARDING_STORE_SYMBOLS.BankAccountStore)
        .to(OnboardingBankAccountStore)
        .inSingletonScope()

    register<OnboardingAddPersonStore>(ONBOARDING_STORE_SYMBOLS.OnboardingAddPersonStore)
        .to(OnboardingAddPersonStore)
        .inSingletonScope()

    register<ApplicationStepsStore>(ONBOARDING_STORE_SYMBOLS.ApplicationStepsStore)
        .to(ApplicationStepsStore)
        .inSingletonScope()
}
